import { BookkeepingItemType } from '@features/reconciliation/enums/bookkeepingItemType'

export interface ParsedSubjectReference {
  id: string
  type: BookkeepingItemType
}

/**
 * Parses a balanceModifier `subjectReference` (e.g. `bill:7Ax5…`) into a bookkeeping
 * item type and id. `bill`, `invoice` and `externalInvoice` are distinct entities and
 * each map to their own type — an external invoice is NOT the same as an invoice.
 */
export const parseSubjectReference = (subjectReference: string | null): ParsedSubjectReference | null => {
  const [prefix, id] = subjectReference?.split(':') ?? []

  if (!prefix || !id) {
    return null
  }

  if (prefix === 'bill') {
    return { id, type: BookkeepingItemType.Bill }
  }

  if (prefix === 'invoice') {
    return { id, type: BookkeepingItemType.Invoice }
  }

  if (prefix === 'externalInvoice') {
    return { id, type: BookkeepingItemType.ExternalInvoice }
  }

  return null
}
